module.exports = __webpack_public_path__ + "img/Cookie_1_resize_20.87702f5a.png";